<template>
  <div>
    <transition name="upload-popup">
    <div v-if="visible && dropZone == false" class="progress-wrap">
      <div class="progress-scrim"></div>
      <div class="progress-box">
      <div class="box">
        <div class="progress-header">
          <div class="is-flex is-justify-between">
            <div class="is-flex">
              <a @click="toggleWindow">
                <b-icon :icon="progressVisible ? 'angle-down' : 'angle-up'" />
              </a>
              <span v-if="activeUploads">
                {{ lang('Uploading files', overallPercent, formatBytes(totalBytes)) }}
              </span>
              <span v-if="activeUploads" class="summary-text">
                ({{ formatSpeed(totalUploadSpeedBytes) }})
              </span>
              <span v-if="activeUploads && paused">
                ({{ lang('Paused') }})
              </span>
              <span v-if="! activeUploads">
                {{ lang('Done') }}
              </span>
              <span v-if="totalUploadsCount" class="summary-text">
                ({{ lang('successful_failed_total', successUploadsCount, failedUploadsCount, totalUploadsCount) }})
              </span>
            </div>
            <div class="is-flex">
              <a v-if="activeUploads" @click="togglePause()">
                <b-icon :icon="paused ? 'play-circle' : 'pause-circle'" />
              </a>
              <a class="progress-icon" @click="closeWindow()">
                <b-icon icon="times" />
              </a>
            </div>
          </div>
        </div>
        <div v-if="progressVisible" class="progress-items">
          <div v-for="entry in entriesHienThi" :key="entry.id" class="progress-entry">
            <div>
              <div class="entry-path" :title="(entry.relativePath != '/' ? entry.relativePath : '') + '/' + entry.fileName">{{ entry.relativePath != '/' ? entry.relativePath : '' }}/{{ entry.fileName }}</div>
              <div class="entry-meta">
                {{ formatBytes(entry.size) }}
                <span v-if="showEntrySpeed(entry)">
                  , {{ formatSpeed(entry.speedBytesPerSecond) }}
                </span>
              </div>
              <div class="is-flex is-justify-between">
                <progress :class="[entryProgressClass(entry), 'progress is-large']" :value="entryProgress(entry)" max="100" />
                <a v-if="showRetry(entry)" class="progress-icon" @click="retryEntry(entry)">
                  <b-icon icon="redo" type="is-danger" />
                </a>
                <a v-else-if="showCancel(entry)" class="progress-icon" @click="cancelEntry(entry)">
                  <b-icon icon="times" />
                </a>
                <a v-else-if="showRemove(entry)" class="progress-icon" @click="removeEntry(entry)">
                  <b-icon icon="times" type="is-danger" />
                </a>
                <span v-else class="progress-icon">
                  <b-icon :icon="entry.isError ? 'times' : 'check'" :type="entry.isError ? 'is-danger' : 'is-success'" />
                </span>
              </div>
            </div>
          </div>
          <div v-if="soDongBiAn > 0" class="progress-con-lai">
            {{ lang('And N more', soDongBiAn) }}
          </div>
        </div>
      </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import Resumable from 'resumablejs'
import Vue from 'vue'
import api from '../../api/api'
import axios from 'axios'
import ConflictDialog from './ConflictDialog'
import _ from 'lodash'

export default {
  name: 'Upload',
  props: [ 'files', 'dropZone' ],
  data() {
    return {
      resumable: {},
      visible: false,
      paused: false,
      progressVisible: false,
      progress: 0,
      uploadEntries: [],
      nextUploadEntryId: 1,
      gioiHanDongHienThi: 300,
      overwriteMap: {},
    }
  },
  computed: {
    activeUploads() {
      return _.some(this.uploadEntries, entry => entry.inProgress)
    },
    totalUploadsCount() {
      return this.uploadEntries.length
    },
    successUploadsCount() {
      return _.filter(this.uploadEntries, entry => entry.isComplete && !entry.isError).length
    },
    failedUploadsCount() {
      return _.filter(this.uploadEntries, entry => entry.isError).length
    },
    totalUploadSpeedBytes() {
      return _.sumBy(this.uploadEntries, entry => entry.inProgress ? entry.speedBytesPerSecond : 0)
    },
    sortedUploadEntries() {
      return _.orderBy(this.uploadEntries, [
        // Loi can xu ly ngay -> dang thuc su truyen du lieu -> da xong ->
        // con dang xep hang cho toi luot. 'dangTruyenThat' la co rieng,
        // duoc CHU DONG cap nhat dung luc co su kien that (khong tinh lai
        // bang cach quet chunks moi lan sap xep - xem cho cap nhat co nay).
        entry => entry.isError ? 0 : (entry.dangTruyenThat ? 1 : (entry.isComplete ? 2 : 3)),
        entry => entry.createdAt,
      ], ['asc', 'asc'])
    },
    // % tong gop tu chinh minh theo doi (currentUploadedBytes da chan san
    // truong hop entry.size<=0 -> tra 0, KHONG goi resumable.progress() cua
    // tung tep - do la cho gay NaN khi tep 0 byte con dang trong trang thai
    // "dang gui" (0/0 = NaN trong phep chia cua thu vien).
    totalBytes() {
      return _.sumBy(this.uploadEntries, 'size')
    },
    uploadedBytes() {
      return _.sumBy(this.uploadEntries, entry => this.currentUploadedBytes(entry))
    },
    overallPercent() {
      if (this.totalBytes <= 0) return 100
      return Math.round(Math.min(100, (this.uploadedBytes / this.totalBytes) * 100))
    },
    // Voi thu muc rat lon (vai nghin tep), VE het tat ca vao DOM cung luc
    // la qua nang (sap xep + doi chieu DOM lai tren moi lan bao tien do,
    // suot ca qua trinh tai - xem giai thich o cho goi $forceUpdate() trong
    // fileProgress). % tong / so tep thanh-cong-that-bai van tinh tren DAY
    // DU uploadEntries (xem totalBytes/uploadedBytes o tren) - chi phan
    // DANH SACH hien thi la bi gioi han, khong mat thong tin tong quan.
    entriesHienThi() {
      return this.sortedUploadEntries.slice(0, this.gioiHanDongHienThi)
    },
    soDongBiAn() {
      return Math.max(0, this.sortedUploadEntries.length - this.gioiHanDongHienThi)
    },
  },
  watch: {
    'files' (files) {
      _.forEach(files, file => {
        this.resumable.addFile(file)
      })
    },
  },
  mounted() {
    // Bien noi bo cho hang doi kiem tra xung dot ten (khong khai trong
    // data() vi ten bat dau bang '_' bi ESLint vue/no-reserved-keys chan -
    // Vue danh rieng tien to nay cho thuoc tinh noi bo cua instance).
    this._hangDoiXungDot = []
    this._dangXuLyXungDot = 0
    this._gioiHanXungDotDongThoi = 4
    this._quyetDinhNhoChoCaLo = null

    this.resumable = new Resumable({
      target: Vue.config.baseURL+'/upload',
      headers: {
        'x-csrf-token': axios.defaults.headers.common['x-csrf-token']
      },
      withCredentials: true,
      simultaneousUploads: this.$store.state.config.upload_simultaneous,
      // Gui kem 'overwrite=1' rieng cho TUNG tep da duoc nguoi dung chon
      // "Ghi de" trong hop thoai xung dot ten (xem overwriteMap).
      query: (file) => {
        return this.overwriteMap[file.uniqueIdentifier] ? { overwrite: '1' } : {}
      },
      minFileSize: 0,
      chunkSize: this.$store.state.config.upload_chunk_size,
      maxFileSize: this.$store.state.config.upload_max_size,
      maxFileSizeErrorCallback: (file) => {
        this.$notification.open({
          message: this.lang('File size error', file.name, this.formatBytes(this.$store.state.config.upload_max_size)),
          type: 'is-danger',
          queue: false,
          indefinite: true,
        })
        this.visible = true
        this.progressVisible = true
        this.createUploadEntry({
          fileName: file.name,
          relativePath: this.$store.state.cwd.location,
          size: file.size,
          retryable: false,
          resumableFile: null,
          inProgress: false,
          isComplete: true,
          isError: true,
        })
        this.$forceUpdate()
      }
    })

    if (!this.resumable.support) {
      this.$dialog.alert({
        type: 'is-danger',
        message: this.lang('Browser not supported.'),
      })
      return
    }

    this.resumable.assignDrop(document.getElementById('dropzone'))

    this.resumable.on('fileAdded', (file) => {
      this.visible = true
      this.progressVisible = true

      if(file.relativePath === undefined || file.relativePath === null || file.relativePath == file.fileName) file.relativePath = this.$store.state.cwd.location
      else file.relativePath = [this.$store.state.cwd.location, file.relativePath].join('/').replace('//', '/').replace(file.fileName, '').replace(/\/$/, '')

      const entry = this.createUploadEntry({
        fileName: file.fileName,
        relativePath: file.relativePath,
        size: file.size,
        retryable: true,
        resumableFile: file,
        inProgress: true,
        isComplete: false,
        isError: false,
      })
      // KHONG resetEntrySpeed() o day - se dat moc tinh toc do qua som (luc
      // tep con XEP HANG CHO, chua thuc su truyen byte nao), lam toc do
      // hien thi thap gia tao voi thu muc nhieu tep. refreshEntrySpeed()
      // (goi tu fileProgress) tu dat moc DUNG LUC nhan byte dau tien that.
      file.file.uploadEntryId = entry.id

      // Kiem tra xung dot ten CHAY SONG SONG voi qua trinh tai binh thuong,
      // KHONG pause truoc nhu ban dau. Ly do: resumable.js co bao ve
      // "upload() toan cuc se KHONG lam gi neu dang co BAT KY tep nao khac
      // dang tai" (xem uploadNextChunk/isUploading trong resumable.js) - voi
      // hang nghin tep chay gan nhu lien tuc, dieu kien "khong con gi dang
      // tai" hau nhu khong bao gio xay ra, nen goi lai upload() sau khi mo
      // pause() 1 tep KHONG chac chan se nhat tep do vao hang cho thuc te -
      // gay tep bi ket mai mai o trang thai cho (da gap that, xem
      // kiemTraXungDotChoTep). Chi pause khi PHAT HIEN xung dot THAT.
      this.themVaoHangDoiXungDot(() => this.kiemTraXungDotChoTep(file))

      if (!this.paused) {
        this.batDauTaiDaDun()
      }
    })

    this.resumable.on('fileSuccess', (file) => {
      file.file.uploadingError = false
      this.updateEntry(file, {
        inProgress: false,
        isComplete: true,
        isError: false,
        dangTruyenThat: false,
      })
      // Chong ro ri bo nho: resumablejs KHONG tu don `chunks` (moi chunk
      // giu 1 XMLHttpRequest da xong viec) khi tep tai THANH CONG - chi
      // don o nhanh loi. Voi hang tram/nghin tep cong don qua nhieu lot
      // trong cung 1 tab, so doi tuong bi giu lai tang khong gioi han
      // cho toi khi trinh duyet bao Out of Memory. Cat ca 2 tham chieu:
      // ben thu vien (removeFile) va ben minh (resumableFile = null).
      // An toan: entryProgress()/currentUploadedBytes() da co nhanh rieng
      // cho isComplete=true, khong con doc resumableFile nua sau khi xong.
      this.resumable.removeFile(file)
      const entry = this.findEntry(file)
      if (entry) entry.resumableFile = null
      this.$forceUpdate()
      if (this.can('read')) {
        api.getDir({
          to: '',
        })
          .then(ret => {
            this.$store.commit('setCwd', {
              content: ret.files,
              location: ret.location,
            })
          })
          .catch(error => this.handleError(error))
      }
    })
    this.resumable.on('fileError', (file) => {
      file.file.uploadingError = true
      this.progressVisible = true
      this.updateEntry(file, {
        speedBytesPerSecond: 0,
        inProgress: false,
        isComplete: true,
        isError: true,
        dangTruyenThat: false,
      })
      this.$forceUpdate()
    })
    this.resumable.on('fileProgress', (file) => {
      this.refreshEntrySpeed(this.findEntry(file))
      this.updateEntry(file, {
        inProgress: true,
        dangTruyenThat: true,
      })
      // Voi nhieu tep tai song song (upload_simultaneous), su kien nay co
      // the no toi ~8 lan/giay cong don - moi lan $forceUpdate() la sap
      // xep + doi chieu lai CA danh sach. Dun toi da 1 lan/300ms de giam
      // tai ma van dam bao giao dien cap nhat muot (mat khong qua 0.3s).
      const gio = Date.now()
      if (!this._lanCapNhatGiaoDienCuoi || gio - this._lanCapNhatGiaoDienCuoi > 300) {
        this._lanCapNhatGiaoDienCuoi = gio
        this.$forceUpdate()
      }
    })
  },
  methods: {
    // Hang doi kiem tra xung dot ten, gioi han dong thoi de khong ban hang
    // nghin request HTTP cung mot luc khi tai ca thu muc lon.
    themVaoHangDoiXungDot(hamViec) {
      this._hangDoiXungDot.push(hamViec)
      this.chayHangDoiXungDot()
    },
    chayHangDoiXungDot() {
      while (this._dangXuLyXungDot < this._gioiHanXungDotDongThoi && this._hangDoiXungDot.length) {
        const viec = this._hangDoiXungDot.shift()
        this._dangXuLyXungDot++
        viec().finally(() => {
          this._dangXuLyXungDot--
          this.chayHangDoiXungDot()
        })
      }
    },
    kiemTraXungDotChoTep(file) {
      return api.checkUploadConflict({ path: file.relativePath, name: file.fileName })
        .then(ret => {
          if (!ret.exists) {
            // Chua ton tai - tep dang/se tu tai binh thuong, khong can hoi.
            return
          }
          // Da ton tai TRUNG TEN - luon hoi, giong Windows that (Windows
          // khong so noi dung/kich thuoc, cu trung ten la hoi). Dung lai
          // (co the da gui vai chunk dau truoc khi kiem tra xong, khong sao -
          // cac chunk do chi nam tam trong tmpfs, chua ghi vao dich that su).
          file.pause(true)
          return this.xuLyXungDot(file, ret.size)
        })
        .catch(() => {
          // Loi khi kiem tra (vd mat mang) - tep van dang tai binh thuong,
          // khong can lam gi (chua he bi pause).
        })
    },
    xuLyXungDot(file, existingSize) {
      if (this._quyetDinhNhoChoCaLo) {
        this.apDungQuyetDinhXungDot(file, this._quyetDinhNhoChoCaLo)
        return Promise.resolve()
      }
      return new Promise(resolve => {
        this.$modal.open({
          parent: this,
          hasModalCard: true,
          canCancel: false,
          props: {
            fileName: file.fileName,
            relativePath: file.relativePath,
            existingSize: existingSize,
            newSize: file.size,
          },
          component: ConflictDialog,
          events: {
            chosen: ({ action, applyToAll }) => {
              if (applyToAll) this._quyetDinhNhoChoCaLo = action
              this.apDungQuyetDinhXungDot(file, action)
              resolve()
            },
          },
        })
      })
    },
    apDungQuyetDinhXungDot(file, action) {
      if (action === 'skip') {
        const entry = this.findEntry(file)
        if (entry) {
          Object.assign(entry, { inProgress: false, isComplete: true, isError: false, dangTruyenThat: false, isSkipped: true })
        }
        file.cancel()
        return
      }
      if (action === 'overwrite') {
        this.$set(this.overwriteMap, file.uniqueIdentifier, true)
      }
      // 'keepboth': khong lam gi them - server tu doi ten qua upcountName().
      file.pause(false)
      // Goi thang uploadNextChunk() thay vi resumable.upload()/batDauTaiDaDun():
      // tep nay VUA duoc mo pause, nhung upload() toan cuc se bo qua vi no chi
      // lam gi khi KHONG co tep nao khac dang tai - voi hang tram tep khac
      // dang chay dong thoi, dieu kien do gan nhu khong bao gio dung, khien
      // tep bi ket vinh vien o trang thai cho (bug da gap that voi tinh nang
      // nay). Goi thang ham noi bo de chac chan tep duoc nhat vao xu ly.
      this.resumable.uploadNextChunk()
    },
    // Goi resumable.upload() 1 LAN duy nhat sau khi toan bo cac su kien
    // fileAdded dong bo cua 1 lan chon (tep don hoac ca thu muc) da chay
    // xong, thay vi goi lai tren TUNG tep - tranh quet lai isUploading()
    // O(N) moi lan, cong don O(N^2) cho ca lot N tep.
    batDauTaiDaDun() {
      if (this._dangDunTai) return
      this._dangDunTai = true
      this.$nextTick(() => {
        this._dangDunTai = false
        this.resumable.upload()
      })
    },
    createUploadEntry({fileName, relativePath, size, retryable, resumableFile, inProgress, isComplete, isError}) {
      const entry = {
        id: this.nextUploadEntryId++,
        fileName,
        relativePath,
        size,
        retryable,
        resumableFile,
        inProgress,
        isComplete,
        isError,
        speedBytesPerSecond: 0,
        speedStartBytes: 0,
        speedStartAt: null,
        createdAt: Date.now() + this.nextUploadEntryId,
        dangTruyenThat: false,
      }

      this.uploadEntries.push(entry)

      return entry
    },
    findEntry(file) {
      return _.find(this.uploadEntries, entry => entry.id == _.get(file, 'file.uploadEntryId'))
    },
    updateEntry(file, values) {
      const entry = this.findEntry(file)
      if (!entry) return

      Object.assign(entry, values)
    },
    entryProgress(entry) {
      if (entry.isComplete) return 100
      if (!entry.resumableFile || entry.size <= 0) return 100

      return entry.resumableFile.progress() * 100
    },
    currentUploadedBytes(entry) {
      if (!entry || entry.size <= 0) return 0
      // Tep da xong: luon tinh du 100% kich thuoc, KHONG doc resumableFile
      // nua - sau khi don bo nho (xem fileSuccess) no da bi dat ve null.
      if (entry.isComplete) return entry.size
      if (!entry.resumableFile) return 0

      return Math.min(entry.size, Math.max(0, entry.resumableFile.progress() * entry.size))
    },
    resetEntrySpeed(entry) {
      if (!entry) return

      const bytesUploaded = this.currentUploadedBytes(entry)

      entry.speedBytesPerSecond = 0
      entry.speedStartBytes = bytesUploaded
      entry.speedStartAt = Date.now()
    },
    refreshEntrySpeed(entry) {
      if (!entry) return

      const now = Date.now()
      const bytesUploaded = this.currentUploadedBytes(entry)

      if (!entry.speedStartAt) {
        this.resetEntrySpeed(entry)
        return
      }

      const elapsedMs = now - entry.speedStartAt
      if (elapsedMs <= 0) {
        entry.speedBytesPerSecond = 0
        return
      }

      const deltaBytes = Math.max(0, bytesUploaded - entry.speedStartBytes)
      entry.speedBytesPerSecond = deltaBytes / (elapsedMs / 1000)
    },
    formatSpeed(bytesPerSecond) {
      const decimals = bytesPerSecond >= 1024 * 1024 ? 1 : 0
      return this.formatBytes(bytesPerSecond || 0, decimals) + '/s'
    },
    entryProgressClass(entry) {
      if (entry.isError) return 'is-danger'
      if (entry.isComplete) return 'is-success'
      return 'is-primary'
    },
    showRetry(entry) {
      return entry.retryable && entry.isError
    },
    showCancel(entry) {
      return entry.inProgress && entry.resumableFile
    },
    showEntrySpeed(entry) {
      return entry.inProgress && entry.resumableFile && entry.speedBytesPerSecond > 0
    },
    showRemove(entry) {
      return entry.isError && !entry.retryable
    },
    retryEntry(entry) {
      if (!entry.resumableFile) return

      entry.isError = false
      entry.isComplete = false
      entry.inProgress = true
      entry.resumableFile.file.uploadingError = false
      this.resetEntrySpeed(entry)
      entry.resumableFile.retry()

      if (!this.paused) {
        this.resumable.upload()
      }

      this.$forceUpdate()
    },
    cancelEntry(entry) {
      if (!entry.resumableFile) return

      entry.resumableFile.cancel()
      this.uploadEntries = _.filter(this.uploadEntries, item => item.id != entry.id)
    },
    removeEntry(entry) {
      this.uploadEntries = _.filter(this.uploadEntries, item => item.id != entry.id)
    },
    closeWindow() {
      // Reset "quyet dinh nho" khi dong khung tien do - tranh 1 lua chon cu
      // (vd tu lan tai truoc) vo tinh ap dung nham cho lan tai hoan toan khac.
      this._quyetDinhNhoChoCaLo = null
      if (this.activeUploads) {
        this.$dialog.confirm({
          message: this.lang('Are you sure you want to stop all uploads?'),
          type: 'is-danger',
          cancelText: this.lang('Cancel'),
          confirmText: this.lang('Confirm'),
          onConfirm: () => {
            this.resumable.cancel()
            this.uploadEntries = []
            this.visible = false
          }
        })
      } else {
        this.visible = false
        this.resumable.cancel()
        this.uploadEntries = []
      }
    },
    toggleWindow() {
      this.progressVisible = ! this.progressVisible
    },
    togglePause() {
      if (this.paused) {
        _.forEach(this.uploadEntries, entry => {
          if (entry.inProgress) {
            this.resetEntrySpeed(entry)
          }
        })
        this.resumable.upload()
        this.paused = false
      } else {
        this.resumable.pause()
        _.forEach(this.uploadEntries, entry => {
          if (entry.inProgress) {
            this.resetEntrySpeed(entry)
          }
        })
        this.paused = true
      }
    },
  },
}
</script>

<style scoped>
.progress-icon {
  margin-left: 15px;
}
.summary-text {
  margin-left: 6px;
}
.entry-meta {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 6px;
}
.upload-popup-enter-active,
.upload-popup-leave-active {
  transition: transform .22s ease, opacity .22s ease;
}
.upload-popup-enter,
.upload-popup-leave-to {
  transform: translateY(16px);
  opacity: 0;
}
.progress-wrap {
  position: fixed;
  inset: 0;
  z-index: 30; /* duoi modal (z-index 40 cua Bulma) de hop thoai luon noi len tren */
  /* Mac dinh KHONG chan click - tai len chay nen, khong nen khoa ca trang
     trong suot thoi gian tai (co the keo dai voi lo lon). Ban than khung
     .progress-box se tu bat lai pointer-events de nut ben trong bam duoc. */
  pointer-events: none;
}
.progress-scrim {
  position: absolute;
  inset: 0;
  background: rgba(20, 16, 10, .28);
}
.progress-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* Khop dung be rong .container cua Bulma ma bang danh sach tep dang dung
     (xem app.css: @media (min-width:1024px){.container{max-width:960px}}).
     Khong dung class "container" truc tiep duoc vi phan tu nay o
     position:fixed chi dat 'left' (khong dat ca 'right') - width:auto cua
     Bulma se co lai theo noi dung thay vi lap day, da kiem chung thuc te. */
  width: calc(100vw - 40px);
}
@media screen and (min-width: 1024px) {
  .progress-box {
    width: 960px;
  }
}
.progress-box {
  max-height: min(75vh, 560px);
  pointer-events: auto;
  display: flex;
  flex-direction: column;
}
.progress-box .box {
  padding: 0;
  border-radius: 12px;
  box-shadow: 0 30px 70px -20px rgba(20,20,20,.4), 0 4px 14px rgba(20,20,20,.14);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}
.progress-header {
  padding: 18px 20px;
  background: #fafafa;
  border-bottom: 1px solid #ececec;
  flex-shrink: 0;
}
.progress-items {
  overflow-y: auto;
  padding: 4px 20px;
}
.progress-entry {
  padding: 13px 0;
}
.progress-entry + .progress-entry {
  border-top: 1px solid #f2f2f2;
}
.progress-con-lai {
  padding: 12px 0 4px;
  text-align: center;
  color: #7a7a7a;
  font-size: .82rem;
  font-style: italic;
}
.entry-path {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: .92rem;
}
</style>
